<vi-panel>
  <div content>
    <div
      class="filter-header flex gt-sm:flex-row lt-md:flex-col gap-[24px] lt-md:gap-[16px] justify-between items-center"
    >
      <div
        class="flex gt-xs:flex-row xs:flex-col gap-[24px] xs:justify-center xs:items-center gt-xs:justify-center gt-xs:items-baseline"
      >
        <app-chip-filters>
          <app-chip-filter
            data-at-filter-pro-subscriptions
            [active]="activeSubscriptionsFilter === subscriptionsFilterType.PRO"
            gtm="onSetFilter"
            gtmAction="Pro"
            gtmCategory="userDetails"
            (click)="setFilter(subscriptionsFilterType.PRO)"
            >{{ '+BOOKING.OVERVIEW.FILTER.PRO_BOOKING' | translate }}</app-chip-filter
          >
          <app-chip-filter
            data-at-filter-plus-subscriptions
            [active]="activeSubscriptionsFilter === subscriptionsFilterType.TRIAL"
            gtm="onSetFilter"
            gtmAction="Trial"
            gtmCategory="userDetails"
            (click)="setFilter(subscriptionsFilterType.TRIAL)"
            >{{ '+BOOKING.OVERVIEW.FILTER.TRIAL' | translate }}</app-chip-filter
          >
        </app-chip-filters>
        <mat-checkbox
          #includeExpiredCheckbox
          gtm="onToggle"
          gtmAction="Include expired bookings"
          gtmCategory="userDetails"
          >{{ '+USER_DETAILS.BOOKINGS.FILTER.EXPIRED_BOOKINGS' | translate }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</vi-panel>
<div class="list-item-wrapper flex flex-col justify-start items-start">
  <div
    class="list-item-header flex flex-row justify-start items-center"
    [class.with-scrollbar]="
      flatRateSubscriptions.length > numberOfFlatRateRowsWithoutScrollbar ||
      trialSubscriptions.length > numberOfTrialRowsWithoutScrollbar
    "
  >
    <!-- Flat rate packages for company header -->
    <ng-container
      *ngIf="
        activeSubscriptionsFilter !== subscriptionsFilterType.TRIAL;
        else trialSubscriptionsHeader
      "
    >
      <div class="package flex-[35%] max-w-[35%]">
        {{ '+USER_DETAILS.PERSONAL_DETAILS.USER_COMPANY' | translate }}
      </div>
      <div class="status flex-[30%] max-w-[30%]">
        {{ '+USER_DETAILS.BOOKINGS.ADDRESS' | translate }}
      </div>
      <div class="details flex-[35%] max-w-[35%]">
        {{ '+USER_DETAILS.BOOKINGS.BOOKINGS_DETAILS' | translate }}
      </div>
    </ng-container>

    <!-- Trial package per installation header -->
    <ng-template #trialSubscriptionsHeader>
      <div class="package flex-[7%] max-w-[7%]">
        {{ '+USER_DETAILS.BOOKINGS.PACKAGE' | translate }}
      </div>
      <div class="status flex-[6%] max-w-[6%]">
        {{ '+USER_DETAILS.BOOKINGS.Status' | translate }}
      </div>
      <div class="device flex-[20%] max-w-[20%]">
        {{ '+USER_DETAILS.BOOKINGS.DEVICE' | translate }}
      </div>
      <div class="owner flex-[25%] max-w-[25%]">
        {{ '+USER_DETAILS.BOOKINGS.OWNER' | translate }}
      </div>
      <div class="details flex-[35%] max-w-[35%]">
        {{ '+USER_DETAILS.BOOKINGS.BOOKINGS_DETAILS' | translate }}
      </div>
    </ng-template>
  </div>

  <cdk-virtual-scroll-viewport [itemSize]="10">
    <!-- Flat rate packages for company -->
    <ng-container
      *ngIf="
        activeSubscriptionsFilter === subscriptionsFilterType.PRO;
        else trialSubscriptionsTable
      "
    >
      <ng-container
        *ngFor="
          let subscription of flatRateSubscriptions
            | sortBookings
              : {
                  filter: activeSubscriptionsFilter,
                  includeExpiredSubscriptions: includeExpiredCheckbox.checked
                }
        "
      >
        <app-flat-rate-row
          class="!flex flex-row"
          [subscription]="subscription"
          [companyId]="userDetailsStore.companyNumber$ | async"
        ></app-flat-rate-row>
      </ng-container>
    </ng-container>

    <!-- Trial packages per installation -->
    <ng-template #trialSubscriptionsTable>
      <ng-container
        *ngFor="
          let subscription of trialSubscriptions
            | sortBookings
              : {
                  filter: activeSubscriptionsFilter,
                  includeExpiredSubscriptions: includeExpiredCheckbox.checked
                }
        "
      >
        <app-package-per-installation-row
          class="!flex flex-row"
          [subscription]="subscription"
        ></app-package-per-installation-row>
      </ng-container>
    </ng-template>
  </cdk-virtual-scroll-viewport>
</div>
